export const DO_CREATE_DOMAIN_START = 'DO_CREATE_DOMAIN_START'
export const DO_CREATE_DOMAIN_SUCCESS = 'DO_CREATE_DOMAIN_SUCCESS'
export const DO_CREATE_DOMAIN_FAIL = 'DO_CREATE_DOMAIN_FAIL'
export const DO_UPDATE_DOMAIN_START = 'DO_UPDATE_DOMAIN_START'
export const DO_UPDATE_DOMAIN_SUCCESS = 'DO_UPDATE_DOMAIN_SUCCESS'
export const DO_UPDATE_DOMAIN_FAIL = 'DO_UPDATE_DOMAIN_FAIL'
export const DO_JOIN_OTHER_DOMAIN_START = 'DO_JOIN_OTHER_DOMAIN_START'
export const DO_JOIN_OTHER_DOMAIN_SUCCESS = 'DO_JOIN_OTHER_DOMAIN_SUCCESS'
export const DO_JOIN_OTHER_DOMAIN_FAIL = 'DO_JOIN_OTHER_DOMAIN_FAIL'
export const DO_APPROVE_DOMAIN_REQUEST_START = 'DO_APPROVE_DOMAIN_REQUEST_START'
export const DO_APPROVE_DOMAIN_REQUEST_SUCCESS = 'DO_APPROVE_DOMAIN_REQUEST_SUCCESS'
export const DO_APPROVE_DOMAIN_REQUEST_FAIL = 'DO_APPROVE_DOMAIN_REQUEST_FAIL'
export const DO_GET_DOMAIN_REQUESTORS_START = 'DO_GET_DOMAIN_REQUESTORS_START'
export const DO_GET_DOMAIN_REQUESTORS_SUCCESS = 'DO_GET_DOMAIN_REQUESTORS_SUCCESS'
export const DO_GET_DOMAIN_REQUESTORS_FAIL = 'DO_GET_DOMAIN_REQUESTORS_FAIL'
export const DO_GET_DOMAINS_BY_USER_ID_START = 'DO_GET_DOMAINS_BY_USER_ID_START'
export const DO_GET_DOMAINS_BY_USER_ID_SUCCESS = 'DO_GET_DOMAINS_BY_USER_ID_SUCCESS'
export const DO_GET_DOMAINS_BY_USER_ID_FAIL = 'DO_GET_DOMAINS_BY_USER_ID_FAIL'
export const DO_GET_OTHER_DOMAINS_BY_USER_ID_START = 'DO_GET_OTHER_DOMAINS_BY_USER_ID_START'
export const DO_GET_OTHER_DOMAINS_BY_USER_ID_SUCCESS = 'DO_GET_OTHER_DOMAINS_BY_USER_ID_SUCCESS'
export const DO_GET_OTHER_DOMAINS_BY_USER_ID_FAIL = 'DO_GET_OTHER_DOMAINS_BY_USER_ID_FAIL'
export const DO_START_USER_DOMAIN_START = 'DO_START_USER_DOMAIN_START'
export const DO_START_USER_DOMAIN_SUCCESS = 'DO_START_USER_DOMAIN_SUCCESS'
export const DO_START_USER_DOMAIN_FAIL = 'DO_START_USER_DOMAIN_FAIL'
export const DO_SET_DOMAIN_INFO_MANUALLY = 'DO_SET_DOMAIN_INFO_MANUALLY'
export const DO_REMOVE_DOMAIN_INFO = 'DO_REMOVE_DOMAIN_INFO'
export const DO_INVITE_USER_TO_DOMAIN_START = 'DO_INVITE_USER_TO_DOMAIN_START'
export const DO_INVITE_USER_TO_DOMAIN_SUCCESS = 'DO_INVITE_USER_TO_DOMAIN_SUCCESS'
export const DO_INVITE_USER_TO_DOMAIN_FAIL = 'DO_INVITE_USER_TO_DOMAIN_FAIL'
export const DO_GET_JOINED_DOMAINS_BY_USER_ID_START = 'DO_GET_JOINED_DOMAINS_BY_USER_ID_START'
export const DO_GET_JOINED_DOMAINS_BY_USER_ID_SUCCESS = 'DO_GET_JOINED_DOMAINS_BY_USER_ID_SUCCESS'
export const DO_GET_JOINED_DOMAINS_BY_USER_ID_FAIL = 'DO_GET_JOINED_DOMAINS_BY_USER_ID_FAIL'